/* Splitting 1.1.0 — same word splitter used by Concept v5.3.1 */
!function(a,b){"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):a.Splitting=b()}(this,function(){"use strict";function q(a,b,c){a.style.setProperty(b,c)}function l(a,b){return a.appendChild(b)}function f(a,b,c,d){var e=x.createElement("span");return b&&(e.className=b),c&&(d||e.setAttribute("data-"+b,c),e.textContent=c),a&&l(a,e)||e}function d(a,b){return a.getAttribute("data-"+b)}function p(a,b){return a&&0!=a.length?a.nodeName?[a]:[].slice.call(a[0].nodeName?a:(b||x).querySelectorAll(a)):[]}function m(a){for(var b=[];a--;)b[a]=[];return b}function y(a,b){a&&a.some(b)}function h(a){return function(b){return a[b]}}function i(a,b,c,d){return{by:a,depends:b,key:c,split:d}}function o(b){return function b(c,d,e){var f=e.indexOf(c);if(-1==f){e.unshift(c);var g=a[c];if(!g)throw new Error("plugin not loaded: "+c);y(g.depends,function(a){b(a,c,e)})}else g=e.indexOf(d),e.splice(f,1),e.splice(g,0,c);return e}(b,0,[]).map(h(a))}function e(b){a[b.by]=b}function z(a,b,d,e,g){a.normalize();var h=[],i=document.createDocumentFragment(),c=(e&&h.push(a.previousSibling),[]);return p(a.childNodes).some(function(a){var j;a.tagName&&!a.hasChildNodes()?c.push(a):a.childNodes&&a.childNodes.length?(c.push(a),h.push.apply(h,z(a,b,d,e,g))):(j=(a=a.wholeText||"").trim()).length&&(" "===a[0]&&c.push(C(" ")),y(""===d&&"function"==typeof Intl.Segmenter?Array.from(new Intl.Segmenter().segment(j)).map(function(a){return a.segment}):j.split(d),function(a,d){d&&g&&c.push(f(i,"whitespace"," ",g)),d=f(i,b,a),h.push(d),c.push(d)})," "===a[a.length-1])&&c.push(C(" "))}),y(c,function(a){l(i,a)}),a.innerHTML="",l(a,i),h}function g(b){var f=(b=b||{}).key;return p(b.target||"[data-splitting]").map(function(a){var e,g,h=a["\uD83C\uDF4C"];return!b.force&&h||(h=a["\uD83C\uDF4C"]={el:a},e=o(e=(e=b.by||d(a,"splitting"))&&"true"!=e?e:"chars"),g=function(a,b){for(var c in b)a[c]=b[c];return a}({},b),y(e,function(b){var c,d,i,j,k;b.split&&(c=b.by,i=(f?"-"+f:"")+b.key,b=b.split(a,g,h),i&&(d=a,k=(i="--"+(i=i))+"-index",y(j=b,function(a,b){Array.isArray(a)?y(a,function(a){q(a,k,b)}):q(a,k,b)}),q(d,i+"-total",j.length)),h[c]=b,a.classList.add(c))}),a.classList.add("splitting")),h})}function b(a,b,c){var b=p(b.matching||a.children,a),d={};return y(b,function(a){var b=Math.round(a[c]);(d[b]||(d[b]=[])).push(a)}),Object.keys(d).map(Number).sort(B).map(h(d))}function B(a,b){return a-b}var x=document,C=x.createTextNode.bind(x),a={},D=0,c="words",n=i(c,D,"word",function(a){return z(a,"word",/\s+/,0,1)}),r=i("chars",[c],"char",function(a,b,d){var e=[];return y(d[c],function(a,c){e.push.apply(e,z(a,"char","",b.whitespace&&c))}),e});g.html=function(a){var b=(a=a||{}).target=f();return b.innerHTML=a.content,g(a),b.outerHTML};var s=i("lines",[c],"line",function(a,d,f){return b(a,{matching:f[c]},"offsetTop")}),t=i("items",D,"item",function(a,b){return p(b.matching||a.children,a)}),u=i("rows",D,"row",function(a,c){return b(a,c,"offsetTop")}),v=i("cols",D,"col",function(a,c){return b(a,c,"offsetLeft")}),w=i("grid",["rows","cols"]),k=i("layout",D,D,function(a,b){for(var g,h,j=b.rows=+(b.rows||d(a,"rows")||1),k=b.columns=+(b.columns||d(a,"columns")||1),m=(b.image=b.image||d(a,"image")||a.currentSrc||a.src,b.image&&(g=p("img",a)[0],b.image=g&&(g.currentSrc||g.src)),b.image&&q(a,"background-image","url("+b.image+")"),j*k),n=[],i=f(D,"cell-grid");m--;)h=f(i,"cell"),f(h,"cell-inner"),n.push(h);return l(a,i),n}),A=i("cellRows",["layout"],"row",function(a,b,c){var d=b.rows,f=m(d);return y(c.layout,function(a,b,c){f[Math.floor(b/(c.length/d))].push(a)}),f}),E=i("cellColumns",["layout"],"col",function(a,b,c){var d=b.columns,e=m(d);return y(c.layout,function(a,b){e[b%d].push(a)}),e}),F=i("cells",["cellRows","cellColumns"],"cell",function(a,b,c){return c.layout});return(g.add=e)(n),e(r),e(s),e(t),e(u),e(v),e(w),e(k),e(A),e(E),e(F),g});

(() => {
  'use strict';

  if (window.__conceptSplittingRevealLoaded) return;
  window.__conceptSplittingRevealLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const titleSelectors = [
    '.email-signup-banner__heading',
    '.banner__heading',
    '.rich-text__heading',
    '.fc-pro__heading',
    '.featured-collection-pro__heading',
    '.collection-list-title',
    '.collection-hero-banner__title',
    '.collection-hero__title',
    '.image-with-text__heading',
    '.related-products__heading',
    '.collapsible-content__heading',
    '.faq__heading',
    '.faq__media-heading',
    '.blog__title',
    '.article-template__title',
    '.main-page-title',
    '.page-title',
    '.title--primary',
    '.customer__title',
    '.customer > h1',
    '.customer > h2',
    '.wl-page__title',
    '.mh-hero__title',
    '.nude-hero__title',
    '.cat-list__heading',
    '.duo-head__heading',
    '.font-showcase__heading',
    '.img-marquee__heading',
    '.ig__heading',
    '.kp-app__title',
    '.collage-wrapper-title',
    '.saleh-heading',
    '.stl__heading',
    '.tst__heading',
    '.vs__heading',
    'main h1.title',
    'main h1.h2.center',
    'main .title-wrapper .title',
    'main .shopify-section .title.inline-richtext',
    'main .shopify-section h2.inline-richtext',
    '[data-heading-reveal]'
  ].join(',');

  const productTitleSelectors = [
    '.product__title > h1',
    'h2.product__title'
  ].join(',');

  const ignoredAncestors = [
    '.card',
    '.card-wrapper',
    '.drawer',
    '.modal',
    '.predictive-search',
    '.facets',
    '.mobile-facets',
    '.accordion',
    'header',
    'footer'
  ].join(',');

  class ConceptAnimateElement extends HTMLElement {
    constructor() {
      super();
      this.loadPromise = new Promise((resolve) => {
        this.resolveLoad = resolve;
      });
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      if (reduceMotion) {
        this.finishImmediately();
        return;
      }

      this.type = this.getAttribute('data-animate') || 'fade-up';
      this.delay = (parseInt(this.getAttribute('data-animate-delay'), 10) || 0);
      this.beforeLoad();

      const load = () => {
        if (this.loaded) return;
        this.loaded = true;
        this.observer?.disconnect();
        this.load();
      };

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) load();
        });
        this.observer.observe(this);
      } else {
        load();
      }
    }

    beforeLoad() {
      this.style.willChange = 'transform, opacity';

      if (this.type === 'fade-up-large') {
        this.style.transform = 'translateY(90%)';
        this.style.opacity = '0';
      } else if (this.type === 'fade-up') {
        this.style.transform = 'translateY(min(2rem, 90%))';
        this.style.opacity = '0';
      } else if (this.type === 'fade-in') {
        this.style.opacity = '0';
      }
    }

    load() {
      const duration = this.type === 'fade-up-large' ? 1000 : 1500;
      const keyframes = this.type === 'fade-in'
        ? [{ opacity: 0 }, { opacity: 1 }]
        : [
            { transform: this.style.transform, opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 }
          ];

      if (typeof this.animate !== 'function') {
        this.style.transition = `transform ${duration}ms cubic-bezier(.16,1,.3,1) ${this.delay}ms, opacity ${duration}ms cubic-bezier(.16,1,.3,1) ${this.delay}ms`;
        requestAnimationFrame(() => {
          this.style.transform = 'translateY(0)';
          this.style.opacity = '1';
        });
        setTimeout(() => this.finish(), duration + this.delay);
        return;
      }

      const animation = this.animate(keyframes, {
        duration,
        delay: this.delay,
        easing: 'cubic-bezier(.16,1,.3,1)',
        fill: 'forwards'
      });

      animation.finished.then(() => this.finish()).catch(() => this.finishImmediately());
    }

    finish() {
      this.style.removeProperty('will-change');
      this.style.transform = 'translateY(0)';
      this.style.opacity = '1';
      this.classList.add('animated');
      this.parentElement?.classList.add('animated');
      this.resolveLoad();
    }

    finishImmediately() {
      this.style.transform = 'none';
      this.style.opacity = '1';
      this.classList.add('animated');
      this.parentElement?.classList.add('animated');
      this.resolveLoad();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  class ConceptSplitWords extends HTMLElement {
    constructor() {
      super();
      this.loadPromise = new Promise((resolve) => {
        this.resolveLoad = resolve;
      });
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      if (reduceMotion || !document.body.hasAttribute('data-title-animation')) {
        this.classList.remove('js-invisible');
        this.resolveLoad();
        return;
      }

      const result = window.Splitting({ target: this, by: 'words' });
      const words = result[0]?.words || [];
      const baseDelay = this.hasAttribute('data-animate-delay')
        ? parseInt(this.getAttribute('data-animate-delay'), 10) || 0
        : 0;
      const type = this.getAttribute('data-animate') || 'fade-up-large';

      words.forEach((word, index) => {
        const wrapper = document.createElement('animate-element');
        wrapper.className = 'block';
        wrapper.setAttribute('data-animate', type);
        wrapper.setAttribute('data-animate-delay', baseDelay + index * 30);

        while (word.firstChild) wrapper.appendChild(word.firstChild);
        word.appendChild(wrapper);
      });

      this.classList.remove('js-invisible');
      const elements = Array.from(this.querySelectorAll('animate-element'));
      Promise.all(elements.map((element) => element.loadPromise)).then(() => this.resolveLoad());
    }
  }

  if (!customElements.get('animate-element')) {
    customElements.define('animate-element', ConceptAnimateElement);
  }

  if (!customElements.get('split-words')) {
    customElements.define('split-words', ConceptSplitWords);
  }

  const shouldIgnore = (heading) => heading.closest(ignoredAncestors);

  const wrapHeading = (heading, type) => {
    if (!heading || heading.dataset.conceptSplitReady === 'true') return;
    if (heading.closest('split-words') || heading.querySelector(':scope > split-words')) {
      heading.dataset.conceptSplitReady = 'true';
      return;
    }
    if (shouldIgnore(heading)) return;

    if (reduceMotion || window.SalehTitleRevealBoot?.expired || !document.body.hasAttribute('data-title-animation')) {
      heading.dataset.conceptSplitReady = 'true';
      return;
    }

    heading.dataset.conceptSplitReady = 'true';
    heading.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');

    const split = document.createElement('split-words');
    split.className = 'split-words js-invisible block';
    split.setAttribute('data-animate', type);

    if (heading.closest('.slideshow, slideshow-component')) {
      split.setAttribute('data-animate-delay', '250');
    }

    while (heading.firstChild) split.appendChild(heading.firstChild);
    heading.appendChild(split);
  };

  const initialize = (root = document) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const regularHeadings = scope.matches?.(titleSelectors)
      ? [scope]
      : Array.from(scope.querySelectorAll(titleSelectors));
    const productHeadings = scope.matches?.(productTitleSelectors)
      ? [scope]
      : Array.from(scope.querySelectorAll(productTitleSelectors));

    regularHeadings.forEach((heading) => wrapHeading(heading, 'fade-up-large'));
    productHeadings.forEach((heading) => wrapHeading(heading, 'fade-up'));
  };

  const boot = () => {
    try {
      initialize(document);
      window.SalehTitleRevealBoot?.ready();
    } catch (error) {
      window.SalehTitleRevealBoot?.fail();
      console.error('Heading animation initialization failed', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('related-products:loaded', (event) => initialize(event.target));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:select', (event) => initialize(event.target));
})();
